export default "__VITE_ASSET__zMDg41QF__"